var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMiniClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_168_4392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33757 6.99977L13.5589 1.77937C13.9283 1.41042 13.9283 0.811473 13.5593 0.442059C13.1899 0.0726276 12.591 0.0726276 12.2216 0.442059L7.00024 5.66246L1.77983 0.441136C1.4104 0.0717047 0.811951 0.0717047 0.44252 0.441136C0.0731062 0.810089 0.0731061 1.40902 0.442059 1.77845L5.66292 6.99977L0.441136 12.2206C0.0717047 12.5896 0.0717047 13.1885 0.441136 13.5579C0.625843 13.7427 0.867818 13.835 1.10978 13.835C1.35175 13.835 1.59373 13.7427 1.77843 13.5579L6.99976 8.33753L12.2206 13.5589C12.4054 13.7436 12.6473 13.8359 12.8893 13.8359C13.1313 13.8359 13.3732 13.7436 13.5579 13.5589C13.9274 13.1899 13.9274 12.591 13.5584 12.2216L8.33757 6.99977Z",
    fill: "#8BBB37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_168_4392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMiniClose);
export default __webpack_public_path__ + "static/media/ic_mini_close.4805d7d6452621441d4506608ffc46da.svg";
export { ForwardRef as ReactComponent };